import 'url-search-params-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5';

import App from './ClientApp';
import ConnectedLocale from './components/ConnectedLocale';
// import Zendesk from './components/Zendesk';
import SAQueryClientProvider from './QueryClient';
import * as serviceWorker from './serviceWorker';
import store from './store';
import { clarity } from 'react-microsoft-clarity';

// Initialize Microsoft Clarity for error tracking and analytics
if (process.env.REACT_APP_MICROSFT_CLARITY_APP_ID) {
  clarity.init(process.env.REACT_APP_MICROSFT_CLARITY_APP_ID);
}
ReactDOM.render(
  <Provider store={store.store}>
    <PersistGate loading={null} persistor={store.persistor}>
      <SAQueryClientProvider>
        <BrowserRouter>
          <QueryParamProvider adapter={ReactRouter5Adapter}>
            <React.StrictMode>
              <ConnectedLocale>
                <>
                  <App />
                  {/*<Zendesk />*/}
                </>
              </ConnectedLocale>
            </React.StrictMode>
          </QueryParamProvider>
        </BrowserRouter>
      </SAQueryClientProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
